import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('access_token') || null
    },
    getters: {
        loggedIn(state) {
            return state.token !== null
        }
    },
    mutations: {
        retrieveToken(state, token) {
            state.token = token
        },
        destroyToken(state) {
            state.token = null
        }
    },
    actions: {
        retrieveToken(context, credentials) {

            return new Promise((resolve, reject) => {
                axios.post('/api/login', {
                    username: credentials.username,
                    password: credentials.password,
                })
                .then(response => {
                    // console.log(response)
                    const token = response.data.access_token
                    localStorage.setItem('access_token', token)
                    localStorage.setItem('user_id', response.data.user_id)
                    context.commit('retrieveToken', token)

                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        destroyToken(context) {

            if (context.getters.loggedIn){

                return new Promise((resolve, reject) => {
                    axios.post('/api/logout', '', {
                        headers: { Authorization: "Bearer " + context.state.token }
                    })
                    .then(response => {
                        //console.log(response)
                        localStorage.removeItem('access_token')
                        localStorage.removeItem('user_id')
                        context.commit('destroyToken')

                        resolve(response)
                    })
                    .catch(error => {
                        //console.log(error)
                        localStorage.removeItem('access_token')
                        localStorage.removeItem('user_id')
                        context.commit('destroyToken')

                        reject(error)
                    })
                })

            }
        },
        resetPass(context, credentials) {

            return new Promise((resolve, reject) => {
                axios.post('/api/reset/request', {
                    email: credentials.username,
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        postResetPassword(context, credentials) {

            return new Promise((resolve, reject) => {
                axios.post('/api/reset/password', {
                    email: credentials.email,
                    password: credentials.password,
                    password_confirmation: credentials.password_confirmation,
                    token: credentials.token,
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        registerUser(context, credentials) {

            return new Promise((resolve, reject) => {
                axios.post('/api/create/user', {
                    nombre: credentials.nombre,
                    apellido: credentials.apellido,
                    email: credentials.email,
                    password: credentials.password,
                    password_confirmation: credentials.password_confirmation,
                    politica_privacidad: credentials.politica_privacidad,
                    aviso_legal: credentials.aviso_legal,
                    comunicaciones_comerciales: credentials.comunicaciones_comerciales,
                })
                .then(response => {

                    axios.post('/api/login', {
                        username: credentials.email,
                        password: credentials.password,
                    })
                    .then(response => {
                        const token = response.data.access_token
                        localStorage.setItem('access_token', token)
                        localStorage.setItem('user_id', response.data.user_id)
                        context.commit('retrieveToken', token)

                        resolve(response)
                    })
                    .catch(error => {
                        //console.log(error)
                        reject(error)
                    })
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        registerUserConsumo(context, credentials) {

            return new Promise((resolve, reject) => {
                axios.post('/api/create/userConsumo', {
                    nombre: credentials.nombre,
                    apellido: credentials.apellido,
                    email: credentials.email,
                    password: credentials.password,
                    password_confirmation: credentials.password_confirmation,
                    politica_privacidad: credentials.politica_privacidad,
                    aviso_legal: credentials.aviso_legal,
                    comunicaciones_comerciales: credentials.comunicaciones_comerciales,
                })
                .then(response => {

                    axios.post('/api/login', {
                        username: credentials.email,
                        password: credentials.password,
                    })
                    .then(response => {
                        const token = response.data.access_token
                        localStorage.setItem('access_token', token)
                        localStorage.setItem('user_id', response.data.user_id)
                        context.commit('retrieveToken', token)

                        resolve(response)
                    })
                    .catch(error => {
                        //console.log(error)
                        reject(error)
                    })
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        editUser(context, credentials) {
            return new Promise((resolve, reject) => {
                const formData = new FormData()
                Object.keys(credentials).forEach((key) => {
                    if(credentials[key]){
                        formData.append(key, credentials[key])
                    }
                })
                axios.post('/api/user/edit', formData, {
                    headers: { 'Authorization': "Bearer " + context.state.token, "Content-Type": "multipart/form-data"}
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        deletePerfil(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/perfil/delete',{
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('user_id')
                    context.commit('destroyToken')
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        ////////////////////////////
        getBanners(context) {

            return new Promise((resolve, reject) => {
                axios.get('/api/banners', {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        getFavoritos(context) {

            return new Promise((resolve, reject) => {
                axios.get('/api/favoritos', {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        getCategories(context) {

            return new Promise((resolve, reject) => {
                axios.get('/api/categories', {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })

        },
        getBusqueda(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/buscar',{
                    texto : data.query,
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        addPresupuesto(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/presupuestos/add',{
                    product_id : data.id,
                },{
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        savePresupuesto(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/presupuestos/save',{
                    presupuesto : data.presupuesto,
                },{
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        editPresupuesto(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/presupuestos/edit',{
                    presupuesto : data.presupuesto.id,
                },{
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        deletePresupuesto(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/presupuestos/delete',{
                    presupuesto : data.presupuesto,
                },{
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        downloadPresupuesto(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/presupuestos/download',{
                    presupuesto : data.presupuesto.id,
                },{
                    responseType: 'blob',
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', data.presupuesto.numero_presupuesto+'.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })

            })
        },
        getPresupuestos(context, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/presupuestos',{
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getProducts(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/products',{
                    serie_id : data.serie_id,
                    view_type : data.view_type
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getProductsComparador(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/products/comparador',{
                    slug : data.slug,
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getComparacion(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/products/comparacion',{
                    product_1 : data.product_1,
                    product_2 : data.product_2,
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getProduct(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/product',{
                    slug : data.slug,
                    comparador : data.comparador,
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getPerfil(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/perfil',{}, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        getRecientes(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/recientes',{}, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
        favoritoToggle(context, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/favorito/toggle',{
                    producto_id : data.id,
                    value: data.value
                }, {
                    headers: { Authorization: "Bearer " + context.state.token }
                })
                .then(response => {
                    //console.log(response)
                    resolve(response)
                })
                .catch(error => {
                    //console.log(error)
                    reject(error)
                })
            })
        },
    }
})

export default store
